<template>
  <div>
    <div :id="id" :style="{height: '400px'}"></div>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  props: {
    id: {
      type: String,
      default: () => ''
    },
    data: {
      type: Array,
      default: () => []
    },
    xData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      item: {
        0: '',
        1: '',
        2: ''
      }
    }
  },
  watch: {
    data: {
      handler(newValue) {
        this.$nextTick(() => {
          this.drawLine(newValue)
        })
      },
      immediate: true,
    },
  },
  methods: {
    drawLine (data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.id))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          borderWidth:'1',
          borderColor:'gray',
          axisPointer: {
            type: 'shadow'
          },
          textStyle:{
            color:'black',
          },
          formatter:(params) => {
            Object.keys(this.item).forEach(itemIndex => {
              this.item[itemIndex] = ''
            })
            let unit = '元'
            for( var i = 0; i<params.length; i++){
              switch (params[0].seriesName) {
                case '第一次加油的次数':
                  unit = '次'
                  break
                case '第一次加油的人数':
                  unit = '人'
                  break
                case '第一次加油的金额':
                  unit = '元'
                  break
                case '第一次加油的升数':
                  unit = '升'
                  break
                case '客单价':
                  unit = '元'
                  break
              }
              this.item[i] = params[i].seriesName + ':' + params[i].value + unit + "<br/>"
            }
            const head = params[0].axisValueLabel + "<br/>"
            return `${head}${this.item[0]}${this.item[1]}${this.item[2]}`
          },
        },
        legend: {
          right: '5%'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        color: ['#ADCD40','#FFAC52', '#3377FF'],
        xAxis: [
          {
            type: 'category',
            data: this.xData
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: data
      }, true)
    }
  }
}
</script>
<style scoped lang="less">

</style>